import { HiDocumentReport } from 'react-icons/hi';
import { TbReportAnalytics } from 'react-icons/tb';
import { TbReport } from 'react-icons/tb';
import { RiDeleteBin4Fill } from 'react-icons/ri';
import { IoTodaySharp } from 'react-icons/io5';
import { GiPriceTag } from 'react-icons/gi';
import { MdOutlineCalendarMonth } from 'react-icons/md';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';

const tiles = [
  {
    sNo: 1,
    link: '/admin/salesRateList?filter=part_number',
    isLink: true,
    icon: <GiPriceTag size="5rem" color="#343a40" />,
    p: 'Sales',
    span: 'Rate',
    isIcon: true,
  },
  {
    sNo: 3,
    link: '/admin/monthlySalesPlanList',
    isLink: true,
    icon: <IoTodaySharp size="5rem" color="#087f5b" />,
    p: 'Monthy',
    span: 'Sales Plan',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/monthlySalesList',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#245278" />,
    p: 'Monthly',
    span: 'Sales',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="Sales & Planning" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
